import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m18.727 12.379-3.5 3.5a.843.843 0 0 1-1.23 0 .843.843 0 0 1 0-1.23l1.995-2.024H10.25a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875h5.742l-1.996-1.996a.843.843 0 0 1 0-1.23.843.843 0 0 1 1.23 0l3.5 3.5a.843.843 0 0 1 0 1.23M9.375 7.375h-1.75a.88.88 0 0 0-.875.875v7c0 .492.383.875.875.875h1.75a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875h-1.75A2.626 2.626 0 0 1 5 15.25v-7a2.626 2.626 0 0 1 2.625-2.625h1.75a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875"
    }, null, -1)
  ]))]))
}
export default { render: render }